import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { AltraParte } from 'src/app/common/models/altraparte';
import { CreazionePraticaStoreService } from '../../../../services/creazione-pratica-store.service';
import { Parte } from 'src/app/common/models/parte';
import { OperationsService } from 'src/app/core/services/operations.service';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { stepMap } from '../../../creazione-pratica-stepper/config/step';
import { ConfigurationUtilService } from 'src/app/core/services/configuration-util-service';

@Component({
  selector: 'step-soggetti-terzi-list-altreparti',
  templateUrl: './step-soggetti-terzi-list-altreparti.component.html',
  styleUrls: ['./step-soggetti-terzi-list-altreparti.component.css']
})
export class StepSoggettiTerziListAltrepartiComponent implements OnInit, OnDestroy {

  readonly PROPERTIES_SETTINGS = PropertiesSettings;

  @Input() associable: boolean;
  @Input() labelComponent: string;
  @Input() action: string;
  @Input() fascicolo;
  @Input() sezione;
  soggetti: { isAssociated: boolean, hasDetailsAnagrafica: boolean, option: AltraParte }[] = [];
  @Output() onReturn: EventEmitter<AltraParte> = new EventEmitter<AltraParte>();
  @Output() onEditAltraParte: EventEmitter<DropDownEvent> = new EventEmitter<DropDownEvent>();
  @Output() actionEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() onDelete: EventEmitter<AltraParte> = new EventEmitter<AltraParte>();
  @Output() onDropDownEvent: EventEmitter<DropDownEvent> = new EventEmitter<DropDownEvent>();
  @Output() onDocumentEvent: EventEmitter<DocumentEvent> = new EventEmitter<DocumentEvent>();
  activeIndex: number;
  associationParte: boolean;
  editingParte: boolean = false;
  parteSelected: AltraParte;
  writable: boolean;
  altreParti: AltraParte[] = [];
  accordions = stepMap;
  currentTab: String = "ASSOCIATIVA";

  componentDestroyed$: Subject<void> = new Subject<void>();

  constructor(
    private viewManager: ViewManagerService,
    private operations: OperationsService, 
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private configurationUtil: ConfigurationUtilService
  ) { 
    this.configurationUtil.descrittoriMap.subscribe(descrittore => {
      if(descrittore) {
        this.writable = descrittore[NomiDescrittoriSezione.SEZIONE_ALTRE_PARTI_FASCICOLO].writable
      }
    })
  }

  ngOnInit() {
    this.creazionePraticaStoreService.soggettoTerzo$.pipe(takeUntil(this.componentDestroyed$)).subscribe(altreParti => {
      if(altreParti){
        this.soggetti = [];
        this.altreParti = altreParti;
        altreParti.forEach(element => {
          let option =  { isAssociated: true, hasDetailsAnagrafica: false, option: element }
          this.soggetti.push(option)
        });
      }
    })

  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }

  openDetail(option: { isAssociated: boolean, hasDetailsAnagrafica: boolean, option: AltraParte }, indice: number) {
    this.actionEmitter.emit(this.labelComponent);
    if (this.activeIndex === undefined || this.activeIndex !== indice) {
      this.resetState();
      this.activeIndex = indice;
      // this.editingParte = true;
      if (!option.hasDetailsAnagrafica && option.option.parte.id && !option.option.parte.id.startsWith('TEMP')) {
        this.getAnagrafica(option.option.parte).subscribe(response => this.refreshElementInArray(indice, response));
      }
    } else {
      this.resetState();
    }
  }

  private getAnagrafica(option: Parte): Observable<Parte> {
    return this.operations.getAnagrafica(ServicePathsSettings.URL_GET_PARTE, option.id, true);
  }

  private refreshElementInArray(indice: number, element: Parte): { isAssociated: boolean, hasDetailsAnagrafica: boolean, option: AltraParte } {
    this.soggetti[indice].option.parte = element;
    return this.soggetti[indice];
  }

  retrieveParte(parte: Parte, option: AltraParte) {
    this.parteSelected = option;
    if (parte) {
      this.altreParti = this.altreParti.map(el => {
        if(el === option) el.parte = parte;
        return el;
      });
      this.creazionePraticaStoreService.setSoggettiTerzi(this.altreParti);
      this.creazionePraticaStoreService.save();
      option.parte = parte;
      this.parteSelected = undefined;
    }
  }

  setTab(type: string) {
    this.currentTab = type;
  }

  disassocia(option: AltraParte) {
    this.onDelete.emit(option);
    // let filtred = this.altreParti.filter(altraparte => altraparte.parte.id !== option.parte.id);
    // this.creazionePraticaStoreService.setSoggettiTerzi(filtred);
    // this.creazionePraticaStoreService.save();
  }

  displayAddDocModal(altraParte: AltraParte) {
    this.onDropDownEvent.emit({ eventType: "allegato", altraParte: altraParte });
  }

  disattivaAltraParte(altraParte: AltraParte) {
    this.onDropDownEvent.emit({ eventType: "disattiva", altraParte: altraParte });
  }

  eliminaAltraParte(altraParte: AltraParte) {
    this.onDropDownEvent.emit({ eventType: "elimina", altraParte: altraParte });
  }

  editParte(altraParte: AltraParte) {
    this.onEditAltraParte.emit({ eventType: "modifica", altraParte: altraParte });
    this.editingParte = false;
    this.activeIndex = undefined;
  }

  onEmitUpdateAnagrafica(parte: Parte, altraParteRetrieved: AltraParte){
    altraParteRetrieved.parte = parte;
    this.operations.updateAnagraficaElementParte(parte).subscribe(
      response => {
        this.onEditAltraParte.emit({ eventType: "modifica", altraParte: altraParteRetrieved });
      }
    );
    this.editingParte = false;
    this.activeIndex = undefined;
  }

  // documento

  onReturnUpdateCallback(event) {
    this.onDocumentEvent.emit(
      {
        documento: event,
        eventType:  'modifica'
      }
    )
  }

  showUploadNewVersionModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'nuova-versione'
      }
    )
  }

  showHistoryModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'storico'
      }
    )
  }

  removeDoc(documento: DocumentoAllegato, entityId: string, sezioneId: string) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        entityId: entityId,
        sezioneId: sezioneId,
        eventType:  'elimina'
      }
    )
  }

  displayDocUpdateMetadatiModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'metadati'
      }
    )
  }
  private resetState(): void {
    this.activeIndex = undefined;
    this.editingParte = false;
    this.associationParte = false;
    this.parteSelected = undefined;
  }
}

type DropDownEvent = {
  altraParte: AltraParte,
  eventType: 'allegato' | 'disattiva' | 'elimina' | 'modifica'
}

type DocumentEvent = {
  documento: DocumentoAllegato,
  altraParte?: AltraParte,
  entityId?: string,
  sezioneId?: string,
  eventType: 'nuova-versione' | 'storico' | 'modifica' | 'elimina' | 'metadati'
}
